import React from "react";
import { cn } from "../../../lib/utils"; 

export const RadioGroupItem = ({ value, id, selectedValue, onValueChange }) => {
  return (
    <input
      type="radio"
      id={id}
      name="radio-group"
      value={value}
      checked={selectedValue === value}
      onChange={() => onValueChange && onValueChange(value)}
      className={cn(
        "h-5 w-5 text-emerald-500 border-gray-300 focus:ring-emerald-500 cursor-pointer"
      )}
    />
  );
};
